import { DataRequest } from "../controls/Data.default";
import { PaginationInput } from "../repository/data.default";
import { retry } from "../utils/http";

export function createGridRequest<
  T extends { data: any[]; totalRecords: number },
>(
  getFn: (input: PaginationInput) => Promise<T>,
  options?: { retry?: boolean },
) {
  return ({ context, pageNumber, pageSize, sort }: DataRequest) => {
    const sortBy = (sort || [])[0]?.key ?? null;
    const sortDescending = (sort || [])[0]?.direction === "desc";

    const call = () =>
      getFn({
        ...context,
        pageNumber,
        pageSize,
        ...(sortBy
          ? {
              sortBy,
              sortDescending,
            }
          : {}),
      });

    const promise = options?.retry ? retry(call) : call();

    return promise.then(({ data, totalRecords }) => ({
      data,
      pageNumber,
      pageSize,
      total: totalRecords,
    }));
  };
}
